import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SkeletonLoader, checkIsPlatform, isValidObject } from '@airtel/air-design-system';
import { useRef, useState } from 'react';
import { Animated, useWindowDimensions } from 'react-native';
export var CarouselImage = props => {
  var imageProps = props.imageProps,
    imageLoaderProps = props.imageLoaderProps,
    aspectRatio = props.aspectRatio,
    accessibilityProps = props.accessibilityProps;
  var _useState = useState(true),
    isLoadingImage = _useState[0],
    setIsLoadingImage = _useState[1];
  var dimensions = useWindowDimensions();
  var isAndroid = checkIsPlatform('android');
  var blurRadius = useRef(new Animated.Value(isAndroid ? 0 : 4)).current;
  var opacity = useRef(new Animated.Value(isAndroid ? 0 : 1)).current;
  var onImageLoaded = () => {
    if (isAndroid) {
      setIsLoadingImage(false);
      return;
    }
    Animated.timing(opacity, {
      toValue: 0,
      duration: 300,
      useNativeDriver: !checkIsPlatform('web')
    }).start();
    Animated.timing(blurRadius, {
      toValue: 0,
      duration: 500,
      useNativeDriver: !checkIsPlatform('web')
    }).start(() => {
      setIsLoadingImage(false);
    });
  };
  return _jsxs(_Fragment, {
    children: [isValidObject(imageLoaderProps) && isLoadingImage && _jsx(Animated.View, Object.assign({
      style: {
        opacity
      }
    }, {
      children: _jsx(SkeletonLoader, Object.assign({
        fullWidth: true,
        height: dimensions.width / aspectRatio
      }, imageLoaderProps))
    })), _jsx(Animated.Image, Object.assign({
      blurRadius: blurRadius,
      onLoadEnd: onImageLoaded
    }, imageProps, accessibilityProps))]
  });
};